import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ReassignAction = ({ users, roleReassign, disabled }) => (
  <RibbonMenu
    name="reassign"
    icon="drivers license"
    message="actions.role.reassign"
    onClick={() => roleReassign(users)}
    disabled={disabled}
    className="aridhia-role-reassign-action-menu"
  />
);

export default ReassignAction;
